import { ConfigurationActions } from './configuration.actions';

// tslint:disable-next-line
export interface ConfigurationState {
}

const initialState: ConfigurationState = {};

export function ConfigurationReducer(state: ConfigurationState = initialState, action: ConfigurationActions = null): ConfigurationState {
  if (action !== null) {
    return state;
  }
}
